import React, { useState, useEffect } from 'react';
import i18n from 'i18next';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { Button } from 'uikit/buttons';

const ScrollToTopButton = ({ className = '', container = null }) => {
  const [shouldShowScrollToTop, setShouldShowScrollToTop] = useState(false);

  useEffect(() => {
    if (!container) return;
    const containerPosition = container && container.getBoundingClientRect().top + window.scrollY;
    const checkScroll = () => {
      setShouldShowScrollToTop(window.scrollY > containerPosition);
    };

    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, [container]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!shouldShowScrollToTop) {
    return null;
  }

  return (
    <Button
      ariaLabel={i18n.t('back-to-top')}
      size="small"
      className={className}
      icon={<ArrowUpwardIcon />}
      text={i18n.t('back-to-top')}
      onClick={scrollToTop}
    />
  );
};

export default ScrollToTopButton;
